import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useReveal() {
  const { pathname } = useLocation();

  useEffect(() => {
    const io = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add("visible"); io.unobserve(e.target); }
      }),
      { threshold: 0.08 }
    );

    let raf2;
    const raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        document.querySelectorAll(".reveal:not(.visible)").forEach(el => io.observe(el));
      });
    });

    return () => { cancelAnimationFrame(raf1); cancelAnimationFrame(raf2); io.disconnect(); };
  }, [pathname]);
}
